import * as authActions from "./auth.actions";

export const authFeatureKey = "authInfo";

const initialState = {
  registerData: {},
  loginData: {},
  errorMsg: "",
  isLoading: false,
  verifyOtp: {},
  verifyMobileAndEmail: {},
  profileData: {},
  isExistPhoneNumber: {},
  verifyOtpForPhone: {},
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case authActions.REGISTER_SUCCESS:
      return {
        ...state,
        registerData: payload,
        isLoading: false,
      };

    case authActions.REGISTER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.REGISTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.VERIFY_MOBILE_AND_EMAIL_SUCCESS:
      return {
        ...state,
        verifyMobileAndEmail: payload,
        isLoading: false,
      };

    case authActions.VERIFY_MOBILE_AND_EMAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.VERIFY_MOBILE_AND_EMAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.LOGIN_SUCCESS:
      return {
        ...state,
        loginData: payload,
        isLoading: false,
      };

    case authActions.LOGIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        verifyOtp: payload,
        isLoading: false,
      };

    case authActions.SOCIAL_LOGIN_USER_SUCCESS:
      return {
        ...state,
        loginData: payload,
        isLoading: false,
      };

    case authActions.SOCIAL_LOGIN_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.SOCIAL_LOGIN_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.VERIFY_OTP_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.VERIFY_OTP_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.GET_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        profileData: payload,
        isLoading: false,
      };

    case authActions.GET_PROFILE_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.GET_PROFILE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.IS_EXIST_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        isExistPhoneNumber: payload,
        isLoading: false,
      };

    case authActions.IS_EXIST_PHONE_NUMBER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.IS_EXIST_PHONE_NUMBER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.RESET_IS_EXIST:
      return {
        ...state,
        isExistPhoneNumber: {},
        errorMsg: "",
      };

    case authActions.RESET_REGISTER:
      return {
        ...state,
        registerData: {},
        errorMsg: "",
      };

    case authActions.UPDATE_PHONE_NUMBER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.UPDATE_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profileData: { ...state.profileData, phone: payload.phone },
      };

    case authActions.UPDATE_PHONE_NUMBER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.LOGOUT_SUCCESS:
      return {
        ...state,
        profileData: {},
        loginData: {},
        isLoading: false,
      };

    case authActions.SEND_OTP_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.SEND_OTP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        verifyOtpForPhone: payload,
      };

    case authActions.SEND_OTP_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };

    case authActions.VERIFY_OTP_REQUEST_FOR_PHONE:
      return {
        ...state,
        isLoading: true,
      };

    case authActions.VERIFY_OTP_SUCCESS_FOR_PHONE:
      return {
        ...state,
        isLoading: false,
        verifyOtpForPhone: payload,
      };

    case authActions.VERIFY_OTP_FAILURE_FOR_PHONE:
      return {
        ...state,
        isLoading: false,
        errorMsg: payload,
      };



    default:
      return state;
  }
};
